import { Component, OnInit, Input } from '@angular/core';
import { NEW_RECIPE } from 'src/models/recipe';
import * as Sentry from "@sentry/angular";
@Component({
  selector: 'app-recipe-list-item',
  templateUrl: './recipe-list-item.component.html',
  styleUrls: ['./recipe-list-item.component.scss']
})
@Sentry.TraceClassDecorator()
export class RecipeListItemComponent implements OnInit {

  @Input() recipe: NEW_RECIPE;

  constructor() { }

  ngOnInit(): void {
    
  }

}
